/**
 * main.js
 * Point d'entrée JavaScript pour le thème movmedix.
 */

// Import d'un composant

document.addEventListener('DOMContentLoaded', () => {
    console.log('Main JS chargé avec succès');
    if (!document.body.classList.contains('home')) {
        console.log('Page interne !');
    }
});
